// client/src/components/Toast/ToastViewport.jsx
import "./Toast.css";

const PLACEMENTS = ["top-end", "center"];

// Errors and warnings interrupt; successes and notices wait their turn.
const ASSERTIVE = new Set(["error", "warning"]);

const GLYPH = {
  success: "✓",
  error: "✕",
  warning: "⚠",
  info: "ℹ",
};

function Toast({ toast, onDismiss }) {
  const { id, variant, content, size, leaving } = toast;

  return (
    <div
      className={[
        "gcu-toast",
        `gcu-toast--${variant}`,
        size === "kiosk" ? "gcu-toast--kiosk" : "",
        leaving ? "is-leaving" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-atomic="true"
    >
      <span className="gcu-toast__glyph" aria-hidden="true">
        {GLYPH[variant]}
      </span>
      <div className="gcu-toast__body">{content}</div>
      {size !== "kiosk" && (
        <button
          type="button"
          className="gcu-toast__close"
          aria-label="Dismiss notification"
          onClick={() => onDismiss(id)}
        >
          <span aria-hidden="true">{"×"}</span>
        </button>
      )}
    </div>
  );
}

export default function ToastViewport({ toasts, onDismiss }) {
  return (
    <>
      {PLACEMENTS.map((placement) => {
        const forPlacement = toasts.filter((t) => t.placement === placement);
        const polite = forPlacement.filter((t) => !ASSERTIVE.has(t.variant));
        const assertive = forPlacement.filter((t) => ASSERTIVE.has(t.variant));

        // Both regions render even when empty. A live region created at the same
        // moment its message appears is frequently missed by screen readers.
        // The individual toasts carry no role or aria-live of their own, because
        // nesting live regions causes double announcements.
        return (
          <div
            key={placement}
            className={`gcu-toast-viewport gcu-toast-viewport--${placement}`}
          >
            <div className="gcu-toast-region" aria-live="polite" aria-atomic="false">
              {polite.map((t) => (
                <Toast key={t.id} toast={t} onDismiss={onDismiss} />
              ))}
            </div>
            <div
              className="gcu-toast-region"
              role="alert"
              aria-live="assertive"
              aria-atomic="false"
            >
              {assertive.map((t) => (
                <Toast key={t.id} toast={t} onDismiss={onDismiss} />
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
}
